import React from 'react'
import { Link, withRouter } from 'react-router-dom';

import { Section, Table, InfosBar, Empty, ProfilePicture, Text } from 'components';
import { Container, Icon } from 'semantic-ui-react'

import { BreadcrumbHelper, Typeof } from 'utils';

const HORSES_PER_PAGE = 10;

class HorseListScene extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      horses: props.horses,
      horseCriteria: '',
      showSensorCreateModal: false
    };

    this.handleHorseSearch = this.handleHorseSearch.bind(this);

    this.handleHorseSelect = this.handleHorseSelect.bind(this);
  }

  componentWillMount() {

    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');
    BreadcrumbHelper.push('Chevaux');
    BreadcrumbHelper.flush();
  }

  handleHorseSearch(criteria) {

    this.setState({
      horseCriteria: criteria
    });
  }

  handleHorseSelect(horse) {
    this.props.history.push(`/horses/${horse.uuid}`);
  }

  render() {

    const { horses } = this.state;

    let columns = [
      {
        id: 'picture',
        header: 'Photo',
        render: (horse) => {
          return (
            <ProfilePicture srcBase64={horse.picture} size="mini" />
          )
        },
        fit: true
      },
      {
        id: 'name',
        header: 'Nom',
        value: (horse) => horse.name,
        fit: true
      },
      {
        id: 'owner',
        header: 'Propriétaire',
        value: (horse) => horse.owner,
        render: (horse, owner) => {
          if (!Typeof.string(owner)) {
            return <Empty />;
          }

          return (
            <Text style={{"capitalize" : true}}>{owner}</Text>
          )
        },
        fit: true
      },
      {
        id: 'stable',
        header: 'Écurie',
        value: (horse) => horse.stable,
        render: (horse, stable) => {
          if (!Typeof.string(stable)) {
            return <Empty />;
          }

          return (
            <Text style={{"capitalize" : true}}>{stable}</Text>
          )
        },
        fit: true
      },
      {
        id: 'clinic',
        header: 'Clinique',
        value: (horse) => {
          let clinic = this.props.clinics.find((e) => e.id === horse.clinic);

          if (!Typeof.object(clinic)) {
            return;
          }

          return clinic.name;
        },
        render: (horse, clinic) => {
          if (!Typeof.string(clinic)) {
            return <Empty />;
          }

          return (
            <Link to={`clinics/${horse.clinic}`}>{clinic}</Link>
          )
        }
      },
      {
        id: 'active',
        header: 'Actif',
        value: (horse) => horse.active,
        render: (horse, active) => {

          return (
            <Icon name={active ? 'checkmark' : 'times'} color={active ? 'green' : 'red'} />
          )
        },
        fit: true
      }
    ];

    return (
      <React.Fragment>
        <Container>

          {/* Users */}
          <Section title="Chevaux" onSearch={this.handleHorseSearch} actions={[]}>

            {horses.length > 0 ? (

              <React.Fragment>

                {/* Number of available horses */}
                <InfosBar mode="column">
                  <span>{horses.length > 1 ? `${horses.length} chevaux disponibles` : '1 cheval disponible'}</span>
                </InfosBar>

                {/* horses list */}
                <Table columns={columns}
                  criteria={this.state.horseCriteria}
                  items={horses}
                  itemsPerPage={HORSES_PER_PAGE}
                  onSelect={this.handleHorseSelect}
                  messageEmpty="Aucun cheval ne correspond à votre recherche"
                  getRowClass={(horse) => !horse.active ? 'warning' : undefined}
                />

              </React.Fragment>

            ) : (

              // No horse available
              <InfosBar mode="row">
                <span>Aucun cheval disponible</span>
              </InfosBar>

            )}

          </Section>

        </Container>

      </React.Fragment>
    );
  }
}

export default withRouter(HorseListScene);
